import { render, staticRenderFns } from "./WorkStation.vue?vue&type=template&id=6de05c8f&scoped=true"
import script from "./WorkStation.vue?vue&type=script&lang=js"
export * from "./WorkStation.vue?vue&type=script&lang=js"
import style0 from "./WorkStation.vue?vue&type=style&index=0&id=6de05c8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de05c8f",
  null
  
)

export default component.exports